import { formatearFecha } from "../../helpers/functionHelpers";
export const emailReservaCreada = (data) => {
return `
      <p>Has recibido un nuevo mensaje autom&aacute;tico de Sanfer.</p>
      <p>
        El proveedor con el correo <strong>${
          data.correoPrv
        }</strong> ha creado una nueva reservación para la fecha <strong>${formatearFecha(
    data.fechaRsv
  )}</strong>
        con el folio <strong>${data.folio}</strong>.
      </p>
      <p>
        Para revisar la información completa de la reserva, consulta la página:<br>
        <a href="https://reservas.sanfer.com.mx/reservacion/${data.folio}">
          https://reservas.sanfer.com.mx/reservacion/${data.folio}
        </a>
      </p>
      <p>Gracias.<br>Equipo Sanfer.</p>
    `;
};
